import * as Long from "long";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
export var checkHasEnoughHumus = function (path) { return function (action, state$) {
    var state = state$.value;
    var costs = action.recipe.cost;
    var missingCost = costs.find(function (cost) {
        var availableCost = selectInventoryResourceInfo(state, cost.id);
        return availableCost.amount.equals(Long.ZERO);
    });
    if (missingCost) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/checks/checkHasEnoughHumus.ts
// module id = 1933
// module chunks = 3